var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { display: "flex" } },
    [
      _c(
        "div",
        { staticClass: "card-form" },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              attrs: {
                layout: _vm.layout,
                model: _vm.form,
                rules: _vm.rules,
                "label-col": _vm.labelCol,
                "wrapper-col": _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "指标项", prop: "pointId" } },
                [
                  _c("a-tree-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      dropdownStyle: { maxHeight: "210px" },
                      "tree-data": _vm.indexIetmTree,
                      "search-placeholder": "请选择指标项",
                    },
                    on: { change: _vm.changTreeData },
                    model: {
                      value: _vm.form.pointId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pointId", $$v)
                      },
                      expression: "form.pointId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "规则名称", prop: "name" } },
                [
                  _c("a-input", {
                    attrs: { allowClear: "" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "题目", prop: "questionIds" } },
                [
                  _c("a-tree-select", {
                    staticStyle: {
                      width: "100%",
                      "max-height": "210px",
                      "overflow-y": "auto",
                    },
                    attrs: {
                      dropdownStyle: { maxHeight: "210px" },
                      "tree-data": _vm.topicTree,
                      "tree-checkable": "",
                      "show-checked-strategy": _vm.SHOW_PARENT,
                      "search-placeholder": "请选择题目",
                    },
                    on: { change: _vm.changTreeData },
                    model: {
                      value: _vm.form.questionIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "questionIds", $$v)
                      },
                      expression: "form.questionIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "计算方式", prop: "type" } },
                [
                  _c(
                    "a-select",
                    {
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: 1 } }, [
                        _vm._v("合计"),
                      ]),
                      _c("a-select-option", { attrs: { value: 2 } }, [
                        _vm._v("其中一项"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "规则", prop: "maxScore" } },
                [
                  _c(
                    "a-input-group",
                    { attrs: { compact: "" } },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "100px", "text-align": "center" },
                        attrs: { placeholder: "最小值", allowClear: "" },
                        model: {
                          value: _vm.form.minScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "minScore", $$v)
                          },
                          expression: "form.minScore",
                        },
                      }),
                      _c("a-input", {
                        staticStyle: {
                          width: "30px",
                          "border-left": "0",
                          "pointer-events": "none",
                          background: "#fff",
                        },
                        attrs: { placeholder: "~", disabled: "" },
                      }),
                      _c("a-input-number", {
                        staticStyle: {
                          width: "100px",
                          "text-align": "center",
                          "border-left": "0",
                        },
                        attrs: { placeholder: "最大值" },
                        model: {
                          value: _vm.form.maxScore,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "maxScore", $$v)
                          },
                          expression: "form.maxScore",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "结果分析" } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openRichTextModal("resultAnalysis")
                        },
                      },
                    },
                    [_vm._v("\n          结果分析 - 富文本编辑\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "建议" } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openRichTextModal("suggestion")
                        },
                      },
                    },
                    [_vm._v("\n          建议 - 富文本编辑\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "margin-top": "20px",
                  },
                },
                [
                  _c(
                    "a-popconfirm",
                    {
                      attrs: { "ok-text": "是", "cancel-text": "否" },
                      on: {
                        confirm: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("p", [
                          _vm._v(
                            "新增问卷模式下，取消操作会导致未保存的表单内容丢失"
                          ),
                        ]),
                        _c("p", [_vm._v("确认要取消吗？")]),
                      ]),
                      _c("a-button", [_vm._v("取消")]),
                    ],
                    2
                  ),
                  _c(
                    "a-button",
                    {
                      staticStyle: { margin: "0px 12px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.saveClick },
                    },
                    [_vm._v("保存")]
                  ),
                  _c("a-button", { on: { click: _vm.prevClick } }, [
                    _vm._v("上一步"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("a-divider", {
        staticStyle: { height: "600px", margin: "0 20px" },
        attrs: { type: "vertical" },
      }),
      _c(
        "div",
        { staticStyle: { flex: "1" } },
        [
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "danger",
                    ghost: "",
                    disabled: !_vm.selectedRowKeys.length,
                  },
                  on: { click: _vm.batchDeleteRow },
                },
                [_vm._v("\n        批量删除\n      ")]
              ),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              rowKey: "id",
              columns: _vm.columns,
              "data-source": _vm.tableData,
              "row-selection": {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
              },
              bordered: "",
              pagination: _vm.pagination,
            },
          }),
        ],
        1
      ),
      _c("EditRuleModal", {
        ref: "editModalRef",
        attrs: {
          treeData: {
            indexIetmTree: _vm.indexIetmTree,
            topicTree: _vm.topicTree,
          },
          evaluationId: _vm.quesData.id || "",
        },
        on: {
          updateTable: function ($event) {
            return _vm.$emit("refreshQuesData")
          },
        },
      }),
      _c("InventoryRichModal", {
        ref: "InventoryRichModalRef",
        on: { handleOk: _vm.richTextHandleOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }